// Invented plots with plausible PUZ rules, until Codrin sends a real one.
import type { Rules, Site } from "../domain/rules.ts";

/** About 3,800 m², street to the south. */
export const SAMPLE_SITE: Site = {
  boundary: [[0, 0], [72, 4], [68, 58], [-3, 52]],
  edges: ["aliniament", "lateral", "posterior", "lateral"],
};

export const SAMPLE_RULES: Rules = {
  pot: 40,
  cut: 2.4,
  maxHeight: 25,
  maxStoreys: 8,
  setbacks: {
    aliniament: { min: 5 },
    lateral: { min: 3, heightRatio: 0.5 },
    posterior: { min: 5, heightRatio: 0.5 },
  },
  parkingPerDwelling: 1.2,
  sources: { pot: "PUZ exemplu", cut: "PUZ exemplu", maxHeight: "PUZ exemplu", maxStoreys: "PUZ exemplu", setbacks: "PUZ exemplu", parking: "PUZ exemplu" },
};

export const SITES: { id: string; name: string; site: Site }[] = [
  { id: "a", name: "Patrulater, stradă la sud (~3.800 m²)", site: SAMPLE_SITE },
  {
    id: "b",
    name: "Colț de stradă, în L (~5.600 m²)",
    site: {
      boundary: [[0, 0], [95, 0], [95, 40], [45, 40], [45, 85], [0, 85]],
      edges: ["aliniament", "lateral", "posterior", "posterior", "lateral", "aliniament"],
    },
  },
  {
    id: "c",
    name: "Lot adânc, front îngust (~2.100 m²)",
    site: {
      boundary: [[0, 0], [30, 0], [32, 70], [2, 70]],
      edges: ["aliniament", "lateral", "posterior", "lateral"],
    },
  },
];

/** Retail park plots: a few hectares off a main road, a PUZ for commerce. */
export const RETAIL_RULES: Rules = {
  pot: 50,
  cut: 1,
  maxHeight: 12,
  maxStoreys: 2,
  setbacks: {
    aliniament: { min: 10 },
    lateral: { min: 5 },
    posterior: { min: 5 },
  },
  minGreen: 20,
  sources: { pot: "PUZ exemplu", cut: "PUZ exemplu", maxHeight: "PUZ exemplu", maxStoreys: "PUZ exemplu", setbacks: "PUZ exemplu", green: "PUZ exemplu" },
};

export const RETAIL_SITES: { id: string; name: string; site: Site }[] = [
  {
    id: "r1",
    name: "Retail: dreptunghi la drum național (~3,3 ha)",
    site: { boundary: [[0, 0], [220, 0], [220, 150], [0, 150]], edges: ["aliniament", "lateral", "posterior", "lateral"] },
  },
  {
    id: "r2",
    name: "Retail: trapez, front lung (~4,6 ha)",
    site: { boundary: [[0, 0], [300, 0], [270, 170], [20, 160]], edges: ["aliniament", "lateral", "posterior", "lateral"] },
  },
  {
    id: "r3",
    name: "Retail: lot adânc, colț de stradă (~2,2 ha)",
    site: { boundary: [[0, 0], [120, 0], [120, 185], [0, 185]], edges: ["aliniament", "lateral", "posterior", "aliniament"] },
  },
];
